// components/useGoogleMaps.ts
import { useContext } from 'react';
import { GoogleMapsContext } from './GoogleMapsProvider';

const useGoogleMaps = () => {
    return useContext(GoogleMapsContext);
};

export default useGoogleMaps;
